import Terms from './Terms';
import { enCourseType } from 'interface/course';
import { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Informations from './Informations';
import CourseSkeleton from './Skeleton';
import Modules from './Modules';
import Upsell from './Upsell';
import KeepWatching from './KeepWatching';
import { CourseTheme } from 'assets/themes/Course';
import { useFacebookPixel } from '../../hooks/facebook';
import { useGoogleAnalytics } from 'hooks/google';
import { useEmitCourseMessages } from 'hooks/emitCourseMessages';
import BlockedReasonMessage from './BlockedReasonMessage';
import { useAppSelector } from 'hooks/redux';
import { withCourseTheme } from 'decorators/withCourseTheme';
import CenteredPage from 'components/Shared/CenteredPage';
import { OfferBanner } from './OfferBanner';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  container: {
    overflowX: 'hidden',
    minHeight: 'calc(95vh - 60px)',
    background: theme.variables.courseTheme.background,
  },
  banner: {
    width: '100%',
    maxHeight: 360,
    objectFit: 'cover',
  },
  moduleContainer: {
    display: 'flex',
  },
}));

const Course = () => {
  const classes = useStyles();
  const course = useAppSelector((state) => state.course);

  useFacebookPixel(course);
  useGoogleAnalytics(course);
  useEmitCourseMessages();

  if (course && course.type === enCourseType.package) {
    return <Redirect to='/vitrine' push />;
  }

  if (!course.id) {
    return (
      <>
        <div aria-label='Carregando informações do curso' className={classes.container}>
          <CourseSkeleton />
        </div>
      </>
    );
  }

  return (
    <>
      <div className={classes.container}>
        <Terms courseStatus={course.status} content={course.terms_content} />
        <OfferBanner courseHash={course.hash} bannerDefault={course?.customizations?.image_cover} />
        <CenteredPage>
          <Informations />
          <BlockedReasonMessage />
          <div className={classes.moduleContainer}>
            <Box width='100%' marginTop={4}>
              <KeepWatching />
              <Modules />
            </Box>
            <Upsell />
          </div>
        </CenteredPage>
      </div>
    </>
  );
};

export default withCourseTheme(Course);
